/**
 * Indicador discreto del estado de almacenamiento.
 *
 * Hasta la Fase 8 no hay sincronización, así que solo se informa de lo que se
 * puede saber de verdad: si los datos están a salvo de un desalojo del
 * navegador. No se inventa un «Sincronizando» que todavía no existe.
 *
 * Va en la cabecera, discreto, sin competir con el contenido.
 */

import { useEffect, useState } from 'react';

import {
  consultarUso,
  formatearBytes,
  solicitarPersistencia,
  type EstadoAlmacenamiento,
} from '../../app/almacenamiento';
import estilos from './EstadoGuardado.module.css';

const TEXTO: Record<EstadoAlmacenamiento, string> = {
  comprobando: 'Comprobando',
  persistente: 'Guardado',
  no_persistente: 'Guardado (sin protección)',
  no_soportado: 'Guardado localmente',
};

export function EstadoGuardado() {
  const [estado, setEstado] = useState<EstadoAlmacenamiento>('comprobando');
  const [detalle, setDetalle] = useState('');

  useEffect(() => {
    let vigente = true;
    void (async () => {
      const resultado = await solicitarPersistencia();
      const uso = await consultarUso();
      if (!vigente) return;
      setEstado(resultado);
      setDetalle(
        resultado === 'persistente'
          ? `Tus datos están guardados en este dispositivo y el navegador no los va a descartar. Uso: ${formatearBytes(uso.usadoBytes)}.`
          : `Tus datos están guardados en este dispositivo. Uso: ${formatearBytes(uso.usadoBytes)}.`,
      );
    })();
    return () => {
      vigente = false;
    };
  }, []);

  return (
    <span
      className={estilos.estado}
      data-estado={estado}
      title={detalle}
      role="status"
      aria-live="polite"
    >
      <span className={estilos.punto} aria-hidden="true" />
      {TEXTO[estado]}
    </span>
  );
}
